import { QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router";

import { AppShell } from "@/components/layout/AppShell";
import { ProfilePage } from "@/features/account/ProfilePage";
import { AuditPage } from "@/features/admin/AuditPage";
import { ImportsPage } from "@/features/imports/ImportsPage";
import { RolesPage } from "@/features/admin/RolesPage";
import { UsersPage } from "@/features/admin/UsersPage";
import { SearchPage } from "@/features/tickets/SearchPage";
import { TicketPage } from "@/features/tickets/TicketPage";
import { TicketsPage } from "@/features/tickets/TicketsPage";
import { LoginPage } from "@/features/auth/LoginPage";
import { DashboardPage } from "@/features/dashboard/DashboardPage";

import { AuthProvider } from "./auth/AuthProvider";
import { RequireAuth, RequirePermission } from "./auth/RequireAuth";
import { NotFoundPage } from "./NotFoundPage";
import { createQueryClient } from "./queryClient";
import { ThemeProvider } from "./theme/ThemeProvider";

const queryClient = createQueryClient();

export function AppRoutes() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="login" element={<LoginPage />} />
        <Route
          element={
            <RequireAuth>
              <AppShell />
            </RequireAuth>
          }
        >
          <Route index element={<DashboardPage />} />
          <Route path="tickets" element={<TicketsPage />} />
          <Route path="tickets/:number" element={<TicketPage />} />
          <Route path="search" element={<SearchPage />} />
          <Route path="profile" element={<ProfilePage />} />
          <Route
            path="admin/users"
            element={
              <RequirePermission anyOf={["admin.users"]}>
                <UsersPage />
              </RequirePermission>
            }
          />
          <Route
            path="admin/roles"
            element={
              <RequirePermission anyOf={["admin.roles"]}>
                <RolesPage />
              </RequirePermission>
            }
          />
          <Route
            path="admin/imports"
            element={
              <RequirePermission anyOf={["admin.import"]}>
                <ImportsPage />
              </RequirePermission>
            }
          />
          <Route
            path="admin/audit"
            element={
              <RequirePermission anyOf={["admin.audit"]}>
                <AuditPage />
              </RequirePermission>
            }
          />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </AuthProvider>
  );
}

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
